import { render, staticRenderFns } from "./DiscountPrice.vue?vue&type=template&id=294b49fb&scoped=true&"
import script from "./DiscountPrice.vue?vue&type=script&lang=ts&"
export * from "./DiscountPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294b49fb",
  null
  
)

export default component.exports